import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SSOCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthFromSSO } = useAuth();

  useEffect(() => {
    const token = params.get('token');
    const userStr = params.get('user');
    const error = params.get('error');

    if (error) {
      navigate(`/login?error=${error}`);
    } else if (token && userStr) {
      try {
        const user = JSON.parse(decodeURIComponent(userStr));
        setAuthFromSSO(token, user);
        navigate('/');
      } catch (e) {
        navigate('/login?error=invalid_response');
      }
    } else {
      navigate('/login?error=missing_token');
    }
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: 16 }}>
      <div style={{ width: 40, height: 40, border: '4px solid #E2E8F0', borderTop: '4px solid #0F2647', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
      <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
      <p style={{ color: '#64748B', fontSize: 14 }}>Completing sign in...</p>
    </div>
  );
}
